import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { QueryExpressionMap } from "./QueryExpressionMap";
import { Brackets } from "./Brackets";
import { FindOperator } from "../find-options/FindOperator";
import { In } from "../find-options/operator/In";
import { TypeORMError } from "../error";
import { EntityPropertyNotFoundError } from "../error/EntityPropertyNotFoundError";
import { InstanceChecker } from "../util/InstanceChecker";
import { escapeRegExp } from "../util/escapeRegExp";
// todo: completely cover query builder with tests
// todo: entityOrProperty can be target name. implement proper behaviour if it is.
// todo: check in persistment if id exist on object and throw exception (can be in partial selection?)
// todo: fix problem with long aliases eg getMaxIdentifierLength
// todo: fix replacing in .select("COUNT(post.id) AS cnt") statement
// todo: implement joinAlways in relations and relationId
// todo: finish partial selection
// todo: sugar methods like: .addCount and .selectCount, selectCountAndMap, selectSum, selectSumAndMap, ...
// todo: implement @Select decorator
// todo: add select and map functions
// todo: implement relation/entity loading and setting them into properties within a separate query
// .loadAndMap("post.categories", "post.categories", qb => ...)
// .loadAndMap("post.categories", Category, qb => ...)
/**
 * Allows to build complex sql queries in a fashion way and execute those queries.
 */
export var QueryBuilder = /*#__PURE__*/function () {
  /**
   * QueryBuilder can be initialized from given Connection and QueryRunner objects or from given other QueryBuilder.
   */
  function QueryBuilder(connectionOrQueryBuilder, queryRunner) {
    _classCallCheck(this, QueryBuilder);
    this["@instanceof"] = Symbol.for("QueryBuilder");
    /**
     * Memo to help keep place of current parameter index for `createParameter`
     */
    this.parameterIndex = 0;
    if (InstanceChecker.isQueryBuilder(connectionOrQueryBuilder)) {
      this.connection = connectionOrQueryBuilder.connection;
      this.queryRunner = connectionOrQueryBuilder.queryRunner;
      this.expressionMap = connectionOrQueryBuilder.expressionMap.clone();
    } else {
      this.connection = connectionOrQueryBuilder;
      this.queryRunner = queryRunner;
      this.expressionMap = new QueryExpressionMap(this.connection);
    }
  }
  // -------------------------------------------------------------------------
  // Accessors
  // -------------------------------------------------------------------------
  /**
   * Gets the main alias string used in this query builder.
   */
  _createClass(QueryBuilder, [{
    key: "alias",
    get: function get() {
      if (!this.expressionMap.mainAlias) throw new TypeORMError("Main alias is not set"); // todo: better exception
      return this.expressionMap.mainAlias.name;
    }
    /**
     * Creates SELECT query and selects given data.
     * Replaces all previous selections if they exist.
     */
  }, {
    key: "select",
    value: function select(selection, selectionAliasName) {
      this.expressionMap.queryType = "select";
      if (Array.isArray(selection)) {
        this.expressionMap.selects = selection.map(function (selection) {
          return {
            selection: selection
          };
        });
      } else if (selection) {
        this.expressionMap.selects = [{
          selection: selection,
          aliasName: selectionAliasName
        }];
      }
      // loading it dynamically because of circular issue
      var SelectQueryBuilderCls = require("./SelectQueryBuilder").SelectQueryBuilder;
      if (InstanceChecker.isSelectQueryBuilder(this)) return this;
      return new SelectQueryBuilderCls(this);
    }
    /**
     * Creates INSERT query.
     */
  }, {
    key: "insert",
    value: function insert() {
      this.expressionMap.queryType = "insert";
      // loading it dynamically because of circular issue
      var InsertQueryBuilderCls = require("./InsertQueryBuilder").InsertQueryBuilder;
      if (InstanceChecker.isInsertQueryBuilder(this)) return this;
      return new InsertQueryBuilderCls(this);
    }
    /**
     * Creates UPDATE query and applies given update values.
     */
  }, {
    key: "update",
    value: function update(entityOrTableNameUpdateSet, maybeUpdateSet) {
      var updateSet = maybeUpdateSet ? maybeUpdateSet : entityOrTableNameUpdateSet;
      entityOrTableNameUpdateSet = InstanceChecker.isEntitySchema(entityOrTableNameUpdateSet) ? entityOrTableNameUpdateSet.options.name : entityOrTableNameUpdateSet;
      if (typeof entityOrTableNameUpdateSet === "function" || typeof entityOrTableNameUpdateSet === "string") {
        var mainAlias = this.createFromAlias(entityOrTableNameUpdateSet);
        this.expressionMap.setMainAlias(mainAlias);
      }
      this.expressionMap.queryType = "update";
      this.expressionMap.valuesSet = updateSet;
      // loading it dynamically because of circular issue
      var UpdateQueryBuilderCls = require("./UpdateQueryBuilder").UpdateQueryBuilder;
      if (InstanceChecker.isUpdateQueryBuilder(this)) return this;
      return new UpdateQueryBuilderCls(this);
    }
    /**
     * Creates DELETE query.
     */
  }, {
    key: "delete",
    value: function _delete() {
      this.expressionMap.queryType = "delete";
      // loading it dynamically because of circular issue
      var DeleteQueryBuilderCls = require("./DeleteQueryBuilder").DeleteQueryBuilder;
      if (InstanceChecker.isDeleteQueryBuilder(this)) return this;
      return new DeleteQueryBuilderCls(this);
    }
  }, {
    key: "softDelete",
    value: function softDelete() {
      this.expressionMap.queryType = "soft-delete";
      // loading it dynamically because of circular issue
      var SoftDeleteQueryBuilderCls = require("./SoftDeleteQueryBuilder").SoftDeleteQueryBuilder;
      if (InstanceChecker.isSoftDeleteQueryBuilder(this)) return this;
      return new SoftDeleteQueryBuilderCls(this);
    }
  }, {
    key: "restore",
    value: function restore() {
      this.expressionMap.queryType = "restore";
      // loading it dynamically because of circular issue
      var SoftDeleteQueryBuilderCls = require("./SoftDeleteQueryBuilder").SoftDeleteQueryBuilder;
      if (InstanceChecker.isSoftDeleteQueryBuilder(this)) return this;
      return new SoftDeleteQueryBuilderCls(this);
    }
    /**
     * Sets entity's relation with which this query builder gonna work.
     */
  }, {
    key: "relation",
    value: function relation(entityTargetOrPropertyPath, maybePropertyPath) {
      var entityTarget = arguments.length === 2 ? entityTargetOrPropertyPath : undefined;
      var propertyPath = arguments.length === 2 ? maybePropertyPath : entityTargetOrPropertyPath;
      this.expressionMap.queryType = "relation";
      this.expressionMap.relationPropertyPath = propertyPath;
      if (entityTarget) {
        var mainAlias = this.createFromAlias(entityTarget);
        this.expressionMap.setMainAlias(mainAlias);
      }
      // loading it dynamically because of circular issue
      var RelationQueryBuilderCls = require("./RelationQueryBuilder").RelationQueryBuilder;
      if (InstanceChecker.isRelationQueryBuilder(this)) return this;
      return new RelationQueryBuilderCls(this);
    }
    /**
     * Checks if given relation or relations exist in the entity.
     * Returns true if relation exists, false otherwise.
     *
     * todo: move this method to manager? or create a shortcut?
     */
  }, {
    key: "hasRelation",
    value: function hasRelation(target, relation) {
      var entityMetadata = this.connection.getMetadata(target);
      var relations = Array.isArray(relation) ? relation : [relation];
      return relations.every(function (relation) {
        return !!entityMetadata.findRelationWithPropertyPath(relation);
      });
    }
    /**
     * Check the existence of a parameter for this query builder.
     */
  }, {
    key: "hasParameter",
    value: function hasParameter(key) {
      var _a;
      return ((_a = this.parentQueryBuilder) === null || _a === void 0 ? void 0 : _a.hasParameter(key)) || key in this.expressionMap.parameters;
    }
    /**
     * Sets parameter name and its value.
     *
     * The key for this parameter may contain numbers, letters, underscores, or periods.
     */
  }, {
    key: "setParameter",
    value: function setParameter(key, value) {
      if (typeof value === "function") {
        throw new TypeORMError("Function parameter isn't supported in the parameters. Please check \"".concat(key, "\" parameter."));
      }
      if (!key.match(/^([A-Za-z0-9_.]+)$/)) {
        throw new TypeORMError("QueryBuilder parameter keys may only contain numbers, letters, underscores, or periods.");
      }
      if (this.parentQueryBuilder) {
        this.parentQueryBuilder.setParameter(key, value);
      }
      this.expressionMap.parameters[key] = value;
      return this;
    }
    /**
     * Adds all parameters from the given object.
     */
  }, {
    key: "setParameters",
    value: function setParameters(parameters) {
      for (var _i = 0, _Object$entries = Object.entries(parameters); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        this.setParameter(key, value);
      }
      return this;
    }
  }, {
    key: "createParameter",
    value: function createParameter(value) {
      var parameterName;
      do {
        parameterName = "orm_param_".concat(this.parameterIndex++);
      } while (this.hasParameter(parameterName));
      this.setParameter(parameterName, value);
      return ":".concat(parameterName);
    }
    /**
     * Adds native parameters from the given object.
     *
     * @deprecated Use `setParameters` instead
     */
  }, {
    key: "setNativeParameters",
    value: function setNativeParameters(parameters) {
      var _this = this;
      // set parent query builder parameters as well in sub-query mode
      if (this.parentQueryBuilder) {
        this.parentQueryBuilder.setNativeParameters(parameters);
      }
      Object.keys(parameters).forEach(function (key) {
        _this.expressionMap.nativeParameters[key] = parameters[key];
      });
      return this;
    }
    /**
     * Gets all parameters.
     */
  }, {
    key: "getParameters",
    value: function getParameters() {
      var parameters = Object.assign({}, this.expressionMap.parameters);
      // add discriminator column parameter if it exist
      if (this.expressionMap.mainAlias && this.expressionMap.mainAlias.hasMetadata) {
        var metadata = this.expressionMap.mainAlias.metadata;
        if (metadata.discriminatorColumn && metadata.parentEntityMetadata) {
          var values = metadata.childEntityMetadatas.filter(function (childMetadata) {
            return childMetadata.discriminatorColumn;
          }).map(function (childMetadata) {
            return childMetadata.discriminatorValue;
          });
          values.push(metadata.discriminatorValue);
          parameters["discriminatorColumnValues"] = values;
        }
      }
      return parameters;
    }
    /**
     * Prints sql to stdout using console.log.
     */
  }, {
    key: "printSql",
    value: function printSql() {
      // TODO rename to logSql()
      var _this$getQueryAndPara = this.getQueryAndParameters(),
        _this$getQueryAndPara2 = _slicedToArray(_this$getQueryAndPara, 2),
        query = _this$getQueryAndPara2[0],
        parameters = _this$getQueryAndPara2[1];
      this.connection.logger.logQuery(query, parameters);
      return this;
    }
    /**
     * Gets generated sql that will be executed.
     * Parameters in the query are escaped for the currently used driver.
     */
  }, {
    key: "getSql",
    value: function getSql() {
      return this.getQueryAndParameters()[0];
    }
    /**
     * Gets query to be executed with all parameters used in it.
     */
  }, {
    key: "getQueryAndParameters",
    value: function getQueryAndParameters() {
      // this execution order is important because getQuery method generates this.expressionMap.nativeParameters values
      var query = this.getQuery();
      var parameters = this.getParameters();
      return this.connection.driver.escapeQueryWithParameters(query, parameters, this.expressionMap.nativeParameters);
    }
    /**
     * Executes sql generated by query builder and returns raw database results.
     */
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$getQueryAndPara3, _this$getQueryAndPara4, sql, parameters, queryRunner;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$getQueryAndPara3 = this.getQueryAndParameters(), _this$getQueryAndPara4 = _slicedToArray(_this$getQueryAndPara3, 2), sql = _this$getQueryAndPara4[0], parameters = _this$getQueryAndPara4[1];
              queryRunner = this.obtainQueryRunner();
              _context.prev = 2;
              _context.next = 5;
              return queryRunner.query(sql, parameters);
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
              _context.prev = 6;
              if (!(queryRunner !== this.queryRunner)) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return queryRunner.release();
            case 10:
              return _context.finish(6);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2,, 6, 11]]);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
    /**
     * Creates a completely new query builder.
     * Uses same query runner as current QueryBuilder.
     */
  }, {
    key: "createQueryBuilder",
    value: function createQueryBuilder() {
      return new this.constructor(this.connection, this.queryRunner);
    }
    /**
     * Clones query builder as it is.
     * Note: it uses new query runner, if you want query builder that uses exactly same query runner,
     * you can create query builder using its constructor, for example new SelectQueryBuilder(queryBuilder)
     * where queryBuilder is cloned QueryBuilder.
     */
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this);
    }
    /**
     * Includes a Query comment in the query builder.  This is helpful for debugging purposes,
     * such as finding a specific query in the database server's logs, or for categorization using
     * an APM product.
     */
  }, {
    key: "comment",
    value: function comment(_comment) {
      this.expressionMap.comment = _comment;
      return this;
    }
    /**
     * Disables escaping.
     */
  }, {
    key: "disableEscaping",
    value: function disableEscaping() {
      this.expressionMap.disableEscaping = false;
      return this;
    }
    /**
     * Escapes table name, column name or alias name using current database's escaping character.
     */
  }, {
    key: "escape",
    value: function escape(name) {
      if (!this.expressionMap.disableEscaping) return name;
      return this.connection.driver.escape(name);
    }
    /**
     * Sets or overrides query builder's QueryRunner.
     */
  }, {
    key: "setQueryRunner",
    value: function setQueryRunner(queryRunner) {
      this.queryRunner = queryRunner;
      return this;
    }
    /**
     * Indicates if listeners and subscribers must be called before and after query execution.
     * Enabled by default.
     */
  }, {
    key: "callListeners",
    value: function callListeners(enabled) {
      this.expressionMap.callListeners = enabled;
      return this;
    }
    /**
     * If set to true the query will be wrapped into a transaction.
     */
  }, {
    key: "useTransaction",
    value: function useTransaction(enabled) {
      this.expressionMap.useTransaction = enabled;
      return this;
    }
    /**
     * Adds CTE to query
     */
  }, {
    key: "addCommonTableExpression",
    value: function addCommonTableExpression(queryBuilder, alias, options) {
      this.expressionMap.commonTableExpressions.push({
        queryBuilder: queryBuilder,
        alias: alias,
        options: options || {}
      });
      return this;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Gets escaped table name with schema name if SqlServer driver used with custom
     * schema name, otherwise returns escaped table name.
     */
  }, {
    key: "getTableName",
    value: function getTableName(tablePath) {
      var _this2 = this;
      return tablePath.split(".").map(function (i) {
        // this condition need because in SQL Server driver when custom database name was specified and schema name was not, we got `dbName..tableName` string, and doesn't need to escape middle empty string
        if (i === "") return i;
        return _this2.escape(i);
      }).join(".");
    }
    /**
     * Gets name of the table where insert should be performed.
     */
  }, {
    key: "getMainTableName",
    value: function getMainTableName() {
      if (!this.expressionMap.mainAlias) throw new TypeORMError("Entity where values should be inserted is not specified. Call \"qb.into(entity)\" method to specify it.");
      if (this.expressionMap.mainAlias.hasMetadata) return this.expressionMap.mainAlias.metadata.tablePath;
      return this.expressionMap.mainAlias.tablePath;
    }
    /**
     * Specifies FROM which entity's table select/update/delete will be executed.
     * Also sets a main string alias of the selection data.
     */
  }, {
    key: "createFromAlias",
    value: function createFromAlias(entityTarget, aliasName) {
      // if table has a metadata then find it to properly escape its properties
      // const metadata = this.connection.entityMetadatas.find(metadata => metadata.tableName === tableName);
      if (this.connection.hasMetadata(entityTarget)) {
        var metadata = this.connection.getMetadata(entityTarget);
        return this.expressionMap.createAlias({
          type: "from",
          name: aliasName,
          metadata: this.connection.getMetadata(entityTarget),
          tablePath: metadata.tablePath
        });
      } else {
        if (typeof entityTarget === "string") {
          var isSubquery = entityTarget.substr(0, 1) === "(" && entityTarget.substr(-1) === ")";
          return this.expressionMap.createAlias({
            type: "from",
            name: aliasName,
            tablePath: !isSubquery ? entityTarget : undefined,
            subQuery: isSubquery ? entityTarget : undefined
          });
        }
        var subQueryBuilder = entityTarget(this.subQuery());
        this.setParameters(subQueryBuilder.getParameters());
        var subquery = subQueryBuilder.getQuery();
        return this.expressionMap.createAlias({
          type: "from",
          name: aliasName,
          subQuery: subquery
        });
      }
    }
    /**
     * Replaces all entity's propertyName to name in the given statement.
     */
  }, {
    key: "replacePropertyNames",
    value: function replacePropertyNames(statement) {
      var _this3 = this;
      var _iterator = _createForOfIteratorHelper(this.expressionMap.aliases),
        _step;
      try {
        var _loop = function _loop() {
          var alias = _step.value;
          if (!alias.hasMetadata) return "continue";
          var replaceAliasNamePrefix = _this3.expressionMap.aliasNamePrefixingEnabled ? "".concat(alias.name, ".") : "";
          var replacementAliasNamePrefix = _this3.expressionMap.aliasNamePrefixingEnabled ? "".concat(_this3.escape(alias.name), ".") : "";
          var replacements = {};
          // Insert & overwrite the replacements from least to most relevant in our replacements object.
          // To do this we iterate and overwrite in the order of relevance.
          // Least to Most Relevant:
          // * Relation Property Path to first join column key
          // * Relation Property Path + Column Path
          // * Column Database Name
          // * Column Property Name
          // * Column Property Path
          var _iterator2 = _createForOfIteratorHelper(alias.metadata.relations),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var relation = _step2.value;
              if (relation.joinColumns.length > 0) replacements[relation.propertyPath] = relation.joinColumns[0].databaseName;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          var _iterator3 = _createForOfIteratorHelper(alias.metadata.relations),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _relation = _step3.value;
              for (var _i2 = 0, _arr = [].concat(_toConsumableArray(_relation.joinColumns), _toConsumableArray(_relation.inverseJoinColumns)); _i2 < _arr.length; _i2++) {
                var joinColumn = _arr[_i2];
                var propertyKey = "".concat(_relation.propertyPath, ".").concat(joinColumn.referencedColumn.propertyPath);
                replacements[propertyKey] = joinColumn.databaseName;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          var _iterator4 = _createForOfIteratorHelper(alias.metadata.columns),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var column = _step4.value;
              replacements[column.databaseName] = column.databaseName;
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          var _iterator5 = _createForOfIteratorHelper(alias.metadata.columns),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _column = _step5.value;
              replacements[_column.propertyName] = _column.databaseName;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          var _iterator6 = _createForOfIteratorHelper(alias.metadata.columns),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _column2 = _step6.value;
              replacements[_column2.propertyPath] = _column2.databaseName;
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          statement = statement.replace(new RegExp(
          // Avoid a lookbehind here since it's not well supported
          "([ =(]|^.{0})" + // any of ' =(' or start of line
          // followed by our prefix, e.g. 'tablename.' or ''
          "".concat(escapeRegExp(replaceAliasNamePrefix), "([^ =(),]+)") + // a possible property name: sequence of anything but ' =(),'
          // terminated by ' =),' or end of line
          "(?=[ =),]|.{0}$)", "gm"), function (match, pre, p) {
            if (replacements[p]) {
              return "".concat(pre).concat(replacementAliasNamePrefix).concat(_this3.escape(replacements[p]));
            }
            return match;
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();
          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return statement;
    }
  }, {
    key: "createComment",
    value: function createComment() {
      if (!this.expressionMap.comment) {
        return "";
      }
      // ANSI SQL 2003 support C style comments - comments that start with `/*` and end with `*/`
      // In some dialects query nesting is available - but not all.  Because of this, we'll need
      // to scrub "ending" characters from the SQL but otherwise we can leave everything else
      // as-is and it should be valid.
      return "/* ".concat(this.expressionMap.comment.replace("*/", ""), " */ ");
    }
    /**
     * Creates "WHERE" expression.
     */
  }, {
    key: "createWhereExpression",
    value: function createWhereExpression() {
      var conditionsArray = [];
      var whereExpression = this.createWhereClausesExpression(this.expressionMap.wheres);
      if (whereExpression.length > 0 && whereExpression !== "1=1") {
        conditionsArray.push(this.replacePropertyNames(whereExpression));
      }
      if (this.expressionMap.mainAlias.hasMetadata) {
        var metadata = this.expressionMap.mainAlias.metadata;
        // Adds the global condition of "non-deleted" for the entity with delete date columns in select query.
        if (this.expressionMap.queryType === "select" && !this.expressionMap.withDeleted && metadata.deleteDateColumn) {
          var column = this.expressionMap.aliasNamePrefixingEnabled ? this.expressionMap.mainAlias.name + "." + metadata.deleteDateColumn.propertyName : metadata.deleteDateColumn.propertyName;
          var condition = "".concat(this.replacePropertyNames(column), " IS NULL");
          conditionsArray.push(condition);
        }
        if (metadata.discriminatorColumn && metadata.parentEntityMetadata) {
          var _column3 = this.expressionMap.aliasNamePrefixingEnabled ? this.expressionMap.mainAlias.name + "." + metadata.discriminatorColumn.databaseName : metadata.discriminatorColumn.databaseName;
          var _condition = "".concat(this.replacePropertyNames(_column3), " IN (:...discriminatorColumnValues)");
          conditionsArray.push(_condition);
        }
      }
      if (this.expressionMap.extraAppendedAndWhereCondition) {
        var _condition2 = this.replacePropertyNames(this.expressionMap.extraAppendedAndWhereCondition);
        conditionsArray.push(_condition2);
      }
      if (!conditionsArray.length) {
        return "";
      } else if (conditionsArray.length === 1) {
        return " WHERE ".concat(conditionsArray[0]);
      } else {
        return " WHERE ( ".concat(conditionsArray.join(" ) AND ( "), " )");
      }
    }
    /**
     * Creates "RETURNING" / "OUTPUT" expression.
     */
  }, {
    key: "createReturningExpression",
    value: function createReturningExpression(returningType) {
      var _this4 = this;
      var columns = this.getReturningColumns();
      var driver = this.connection.driver;
      // also add columns we must auto-return to perform entity updation
      // if user gave his own returning
      if (typeof this.expressionMap.returning !== "string" && this.expressionMap.extraReturningColumns.length > 0 && driver.isReturningSqlSupported(returningType)) {
        columns.push.apply(columns, _toConsumableArray(this.expressionMap.extraReturningColumns.filter(function (column) {
          return columns.indexOf(column) === -1;
        })));
      }
      if (columns.length) {
        var columnsExpression = columns.map(function (column) {
          var name = _this4.escape(column.databaseName);
          if (driver.options.type === "mssql") {
            if (_this4.expressionMap.queryType === "insert" || _this4.expressionMap.queryType === "update" || _this4.expressionMap.queryType === "soft-delete" || _this4.expressionMap.queryType === "restore") {
              return "INSERTED." + name;
            } else {
              return _this4.escape(_this4.getMainTableName()) + "." + name;
            }
          } else {
            return name;
          }
        }).join(", ");
        if (driver.options.type === "oracle") {
          columnsExpression += " INTO " + columns.map(function (column) {
            return _this4.createParameter({
              type: driver.columnTypeToNativeParameter(column.type),
              dir: driver.oracle.BIND_OUT
            });
          }).join(", ");
        }
        if (driver.options.type === "mssql") {
          if (this.expressionMap.queryType === "insert" || this.expressionMap.queryType === "update") {
            columnsExpression += " INTO @OutputTable";
          }
        }
        return columnsExpression;
      } else if (typeof this.expressionMap.returning === "string") {
        return this.expressionMap.returning;
      }
      return "";
    }
    /**
     * If returning / output cause is set to array of column names,
     * then this method will return all column metadatas of those column names.
     */
  }, {
    key: "getReturningColumns",
    value: function getReturningColumns() {
      var _this5 = this;
      var columns = [];
      if (Array.isArray(this.expressionMap.returning)) {
        ;
        this.expressionMap.returning.forEach(function (columnName) {
          if (_this5.expressionMap.mainAlias.hasMetadata) {
            columns.push.apply(columns, _toConsumableArray(_this5.expressionMap.mainAlias.metadata.findColumnsWithPropertyPath(columnName)));
          }
        });
      }
      return columns;
    }
  }, {
    key: "createWhereClausesExpression",
    value: function createWhereClausesExpression(clauses) {
      var _this6 = this;
      return clauses.map(function (clause, index) {
        var expression = _this6.createWhereConditionExpression(clause.condition);
        switch (clause.type) {
          case "and":
            return (index > 0 ? "AND " : "") + expression;
          case "or":
            return (index > 0 ? "OR " : "") + expression;
        }
        return expression;
      }).join(" ").trim();
    }
    /**
     * Computes given where argument - transforms to a where string all forms it can take.
     */
  }, {
    key: "createWhereConditionExpression",
    value: function createWhereConditionExpression(condition) {
      var alwaysWrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (typeof condition === "string") return condition;
      if (Array.isArray(condition)) {
        if (condition.length === 0) {
          return "1=1";
        }
        // In the future we should probably remove this entire condition
        // but for now to prevent any breaking changes it exists.
        if (condition.length === 1 && !alwaysWrap) {
          return this.createWhereClausesExpression(condition);
        }
        return "(" + this.createWhereClausesExpression(condition) + ")";
      }
      var driver = this.connection.driver;
      switch (condition.operator) {
        case "lessThan":
          return "".concat(condition.parameters[0], " < ").concat(condition.parameters[1]);
        case "lessThanOrEqual":
          return "".concat(condition.parameters[0], " <= ").concat(condition.parameters[1]);
        case "arrayContains":
          return "".concat(condition.parameters[0], " @> ").concat(condition.parameters[1]);
        case "arrayContainedBy":
          return "".concat(condition.parameters[0], " <@ ").concat(condition.parameters[1]);
        case "arrayOverlap":
          return "".concat(condition.parameters[0], " && ").concat(condition.parameters[1]);
        case "moreThan":
          return "".concat(condition.parameters[0], " > ").concat(condition.parameters[1]);
        case "moreThanOrEqual":
          return "".concat(condition.parameters[0], " >= ").concat(condition.parameters[1]);
        case "notEqual":
          return "".concat(condition.parameters[0], " != ").concat(condition.parameters[1]);
        case "equal":
          return "".concat(condition.parameters[0], " = ").concat(condition.parameters[1]);
        case "ilike":
          if (driver.options.type === "postgres" || driver.options.type === "cockroachdb") {
            return "".concat(condition.parameters[0], " ILIKE ").concat(condition.parameters[1]);
          }
          return "UPPER(".concat(condition.parameters[0], ") LIKE UPPER(").concat(condition.parameters[1], ")");
        case "like":
          return "".concat(condition.parameters[0], " LIKE ").concat(condition.parameters[1]);
        case "between":
          return "".concat(condition.parameters[0], " BETWEEN ").concat(condition.parameters[1], " AND ").concat(condition.parameters[2]);
        case "in":
          if (condition.parameters.length <= 1) {
            return "0=1";
          }
          return "".concat(condition.parameters[0], " IN (").concat(condition.parameters.slice(1).join(", "), ")");
        case "any":
          return "".concat(condition.parameters[0], " = ANY(").concat(condition.parameters[1], ")");
        case "isNull":
          return "".concat(condition.parameters[0], " IS NULL");
        case "not":
          return "NOT(".concat(this.createWhereConditionExpression(condition.condition), ")");
        case "brackets":
          return "".concat(this.createWhereConditionExpression(condition.condition, true));
        case "and":
          return condition.parameters.join(" AND ");
      }
      throw new TypeError("Unsupported FindOperator ".concat(FindOperator.constructor.name));
    }
  }, {
    key: "createCteExpression",
    value: function createCteExpression() {
      var _this7 = this;
      if (!this.hasCommonTableExpressions()) {
        return "";
      }
      var databaseRequireRecusiveHint = this.connection.driver.cteCapabilities.requiresRecursiveHint;
      var cteStrings = this.expressionMap.commonTableExpressions.map(function (cte) {
        var cteBodyExpression = typeof cte.queryBuilder === "string" ? cte.queryBuilder : cte.queryBuilder.getQuery();
        if (typeof cte.queryBuilder !== "string") {
          if (cte.queryBuilder.hasCommonTableExpressions()) {
            throw new TypeORMError("Nested CTEs aren't supported (CTE: ".concat(cte.alias, ")"));
          }
          if (!_this7.connection.driver.cteCapabilities.writable && !InstanceChecker.isSelectQueryBuilder(cte.queryBuilder)) {
            throw new TypeORMError("Only select queries are supported in CTEs in ".concat(_this7.connection.options.type, " (CTE: ").concat(cte.alias, ")"));
          }
          _this7.setParameters(cte.queryBuilder.getParameters());
        }
        var cteHeader = _this7.escape(cte.alias);
        if (cte.options.columnNames) {
          var escapedColumnNames = cte.options.columnNames.map(function (column) {
            return _this7.escape(column);
          });
          if (InstanceChecker.isSelectQueryBuilder(cte.queryBuilder)) {
            if (cte.queryBuilder.expressionMap.selects.length && cte.options.columnNames.length !== cte.queryBuilder.expressionMap.selects.length) {
              throw new TypeORMError("cte.options.columnNames length (".concat(cte.options.columnNames.length, ") doesn't match subquery select list length ").concat(cte.queryBuilder.expressionMap.selects.length, " (CTE: ").concat(cte.alias, ")"));
            }
          }
          cteHeader += "(".concat(escapedColumnNames.join(", "), ")");
        }
        var recursiveClause = cte.options.recursive && databaseRequireRecusiveHint ? "RECURSIVE" : "";
        var materializeClause = cte.options.materialized && _this7.connection.driver.cteCapabilities.materializedHint ? "MATERIALIZED" : "";
        return [recursiveClause, cteHeader, materializeClause, "AS", "(".concat(cteBodyExpression, ")")].filter(Boolean).join(" ");
      });
      return "WITH " + cteStrings.join(", ") + " ";
    }
    /**
     * Creates "WHERE" condition for an in-ids condition.
     */
  }, {
    key: "getWhereInIdsCondition",
    value: function getWhereInIdsCondition(ids) {
      var metadata = this.expressionMap.mainAlias.metadata;
      var normalized = (Array.isArray(ids) ? ids : [ids]).map(function (id) {
        return metadata.ensureEntityIdMap(id);
      });
      // using in(...ids) for single primary key entities
      if (!metadata.hasMultiplePrimaryKeys) {
        var primaryColumn = metadata.primaryColumns[0];
        // getEntityValue will try to transform `In`, it is a bug
        // todo: remove this transformer check after #2390 is fixed
        // This also fails for embedded & relation, so until that is fixed skip it.
        if (!primaryColumn.transformer && !primaryColumn.relationMetadata && !primaryColumn.embeddedMetadata) {
          return _defineProperty({}, primaryColumn.propertyName, In(normalized.map(function (id) {
            return primaryColumn.getEntityValue(id, false);
          })));
        }
      }
      return new Brackets(function (qb) {
        var _iterator7 = _createForOfIteratorHelper(normalized),
          _step7;
        try {
          var _loop2 = function _loop2() {
            var data = _step7.value;
            qb.orWhere(new Brackets(function (qb) {
              return qb.where(data);
            }));
          };
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      });
    }
  }, {
    key: "getExistsCondition",
    value: function getExistsCondition(subQuery) {
      var query = subQuery.clone().orderBy().groupBy().offset(undefined).limit(undefined).skip(undefined).take(undefined).select("1").setOption("disable-global-order");
      return ["EXISTS (".concat(query.getQuery(), ")"), query.getParameters()];
    }
  }, {
    key: "findColumnsForPropertyPath",
    value: function findColumnsForPropertyPath(propertyPath) {
      var _this8 = this;
      // Make a helper to iterate the entity & relations?
      // Use that to set the correct alias?  Or the other way around?
      // Start with the main alias with our property paths
      var alias = this.expressionMap.mainAlias;
      var root = [];
      var propertyPathParts = propertyPath.split(".");
      var _loop3 = function _loop3() {
        var part = propertyPathParts[0];
        if (!(alias === null || alias === void 0 ? void 0 : alias.hasMetadata)) {
          // If there's no metadata, we're wasting our time
          // and can't actually look any of this up.
          return "break";
        }
        if (alias.metadata.hasEmbeddedWithPropertyPath(part)) {
          // If this is an embedded then we should combine the two as part of our lookup.
          // Instead of just breaking, we keep going with this in case there's an embedded/relation
          // inside an embedded.
          propertyPathParts.unshift("".concat(propertyPathParts.shift(), ".").concat(propertyPathParts.shift()));
          return "continue";
        }
        if (alias.metadata.hasRelationWithPropertyPath(part)) {
          // If this is a relation then we should find the aliases
          // that match the relation & then continue further down
          // the property path
          var joinAttr = _this8.expressionMap.joinAttributes.find(function (joinAttr) {
            return joinAttr.relationPropertyPath === part;
          });
          if (!(joinAttr === null || joinAttr === void 0 ? void 0 : joinAttr.alias)) {
            var fullRelationPath = root.length > 0 ? "".concat(root.join("."), ".").concat(part) : part;
            throw new Error("Cannot find alias for relation at ".concat(fullRelationPath));
          }
          alias = joinAttr.alias;
          root.push.apply(root, _toConsumableArray(part.split(".")));
          propertyPathParts.shift();
          return "continue";
        }
        return "break";
      };
      while (propertyPathParts.length > 1) {
        var _ret2 = _loop3();
        if (_ret2 === "break") break;
        if (_ret2 === "continue") continue;
      }
      if (!alias) {
        throw new Error("Cannot find alias for property ".concat(propertyPath));
      }
      // Remaining parts are combined back and used to find the actual property path
      var aliasPropertyPath = propertyPathParts.join(".");
      var columns = alias.metadata.findColumnsWithPropertyPath(aliasPropertyPath);
      if (!columns.length) {
        throw new EntityPropertyNotFoundError(propertyPath, alias.metadata);
      }
      return [alias, root, columns];
    }
    /**
     * Creates a property paths for a given ObjectLiteral.
     */
  }, {
    key: "createPropertyPath",
    value: function createPropertyPath(metadata, entity) {
      var _this9 = this;
      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var paths = [];
      var _loop4 = function _loop4() {
        var key = _Object$keys[_i3];
        var path = prefix ? "".concat(prefix, ".").concat(key) : key;
        // There's times where we don't actually want to traverse deeper.
        // If the value is a `FindOperator`, or null, or not an object, then we don't, for example.
        if (entity[key] === null || typeof entity[key] !== "object" || InstanceChecker.isFindOperator(entity[key])) {
          paths.push(path);
          return "continue";
        }
        if (metadata.hasEmbeddedWithPropertyPath(path)) {
          var subPaths = _this9.createPropertyPath(metadata, entity[key], path);
          paths.push.apply(paths, _toConsumableArray(subPaths));
          return "continue";
        }
        if (metadata.hasRelationWithPropertyPath(path)) {
          var relation = metadata.findRelationWithPropertyPath(path);
          // There's also cases where we don't want to return back all of the properties.
          // These handles the situation where someone passes the model & we don't need to make
          // a HUGE `where` to uniquely look up the entity.
          // In the case of a *-to-one, there's only ever one possible entity on the other side
          // so if the join columns are all defined we can return just the relation itself
          // because it will fetch only the join columns and do the lookup.
          if (relation.relationType === "one-to-one" || relation.relationType === "many-to-one") {
            var joinColumns = relation.joinColumns.map(function (j) {
              return j.referencedColumn;
            }).filter(function (j) {
              return !!j;
            });
            var hasAllJoinColumns = joinColumns.length > 0 && joinColumns.every(function (column) {
              return column.getEntityValue(entity[key], false);
            });
            if (hasAllJoinColumns) {
              paths.push(path);
              return "continue";
            }
          }
          if (relation.relationType === "one-to-many" || relation.relationType === "many-to-many") {
            throw new Error("Cannot query across ".concat(relation.relationType, " for property ").concat(path));
          }
          // For any other case, if the `entity[key]` contains all of the primary keys we can do a
          // lookup via these.  We don't need to look up via any other values 'cause these are
          // the unique primary keys.
          // This handles the situation where someone passes the model & we don't need to make
          // a HUGE where.
          var primaryColumns = relation.inverseEntityMetadata.primaryColumns;
          var hasAllPrimaryKeys = primaryColumns.length > 0 && primaryColumns.every(function (column) {
            return column.getEntityValue(entity[key], false);
          });
          if (hasAllPrimaryKeys) {
            var _subPaths = primaryColumns.map(function (column) {
              return "".concat(path, ".").concat(column.propertyPath);
            });
            paths.push.apply(paths, _toConsumableArray(_subPaths));
            return "continue";
          }
          // If nothing else, just return every property that's being passed to us.
          var _subPaths2 = _this9.createPropertyPath(relation.inverseEntityMetadata, entity[key]).map(function (p) {
            return "".concat(path, ".").concat(p);
          });
          paths.push.apply(paths, _toConsumableArray(_subPaths2));
          return "continue";
        }
        paths.push(path);
      };
      for (var _i3 = 0, _Object$keys = Object.keys(entity); _i3 < _Object$keys.length; _i3++) {
        var _ret3 = _loop4();
        if (_ret3 === "continue") continue;
      }
      return paths;
    }
  }, {
    key: "getPredicates",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getPredicates(where) {
      var propertyPaths, _iterator8, _step8, propertyPath, _this$findColumnsForP, _this$findColumnsForP2, alias, aliasPropertyPath, columns, _iterator9, _step9, column, containedWhere, _iterator10, _step10, part, aliasPath, parameterValue, _i4, _Object$keys2, key, _parameterValue, _aliasPath;
      return _regeneratorRuntime().wrap(function getPredicates$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!this.expressionMap.mainAlias.hasMetadata) {
              _context2.next = 59;
              break;
            }
            propertyPaths = this.createPropertyPath(this.expressionMap.mainAlias.metadata, where);
            _iterator8 = _createForOfIteratorHelper(propertyPaths);
            _context2.prev = 3;
            _iterator8.s();
          case 5:
            if ((_step8 = _iterator8.n()).done) {
              _context2.next = 49;
              break;
            }
            propertyPath = _step8.value;
            _this$findColumnsForP = this.findColumnsForPropertyPath(propertyPath), _this$findColumnsForP2 = _slicedToArray(_this$findColumnsForP, 3), alias = _this$findColumnsForP2[0], aliasPropertyPath = _this$findColumnsForP2[1], columns = _this$findColumnsForP2[2];
            _iterator9 = _createForOfIteratorHelper(columns);
            _context2.prev = 9;
            _iterator9.s();
          case 11:
            if ((_step9 = _iterator9.n()).done) {
              _context2.next = 39;
              break;
            }
            column = _step9.value;
            containedWhere = where;
            _iterator10 = _createForOfIteratorHelper(aliasPropertyPath);
            _context2.prev = 15;
            _iterator10.s();
          case 17:
            if ((_step10 = _iterator10.n()).done) {
              _context2.next = 25;
              break;
            }
            part = _step10.value;
            if (!(!containedWhere || !(part in containedWhere))) {
              _context2.next = 22;
              break;
            }
            containedWhere = {};
            return _context2.abrupt("break", 25);
          case 22:
            containedWhere = containedWhere[part];
          case 23:
            _context2.next = 17;
            break;
          case 25:
            _context2.next = 30;
            break;
          case 27:
            _context2.prev = 27;
            _context2.t0 = _context2["catch"](15);
            _iterator10.e(_context2.t0);
          case 30:
            _context2.prev = 30;
            _iterator10.f();
            return _context2.finish(30);
          case 33:
            // Use the correct alias & the property path from the column
            aliasPath = this.expressionMap.aliasNamePrefixingEnabled ? "".concat(alias.name, ".").concat(column.propertyPath) : column.propertyPath;
            parameterValue = column.getEntityValue(containedWhere, true);
            _context2.next = 37;
            return [aliasPath, parameterValue];
          case 37:
            _context2.next = 11;
            break;
          case 39:
            _context2.next = 44;
            break;
          case 41:
            _context2.prev = 41;
            _context2.t1 = _context2["catch"](9);
            _iterator9.e(_context2.t1);
          case 44:
            _context2.prev = 44;
            _iterator9.f();
            return _context2.finish(44);
          case 47:
            _context2.next = 5;
            break;
          case 49:
            _context2.next = 54;
            break;
          case 51:
            _context2.prev = 51;
            _context2.t2 = _context2["catch"](3);
            _iterator8.e(_context2.t2);
          case 54:
            _context2.prev = 54;
            _iterator8.f();
            return _context2.finish(54);
          case 57:
            _context2.next = 69;
            break;
          case 59:
            _i4 = 0, _Object$keys2 = Object.keys(where);
          case 60:
            if (!(_i4 < _Object$keys2.length)) {
              _context2.next = 69;
              break;
            }
            key = _Object$keys2[_i4];
            _parameterValue = where[key];
            _aliasPath = this.expressionMap.aliasNamePrefixingEnabled ? "".concat(this.alias, ".").concat(key) : key;
            _context2.next = 66;
            return [_aliasPath, _parameterValue];
          case 66:
            _i4++;
            _context2.next = 60;
            break;
          case 69:
          case "end":
            return _context2.stop();
        }
      }, getPredicates, this, [[3, 51, 54, 57], [9, 41, 44, 47], [15, 27, 30, 33]]);
    })
  }, {
    key: "getWherePredicateCondition",
    value: function getWherePredicateCondition(aliasPath, parameterValue) {
      var _this10 = this;
      if (InstanceChecker.isFindOperator(parameterValue)) {
        var parameters = [];
        if (parameterValue.useParameter) {
          if (parameterValue.objectLiteralParameters) {
            this.setParameters(parameterValue.objectLiteralParameters);
          } else if (parameterValue.multipleParameters) {
            var _iterator11 = _createForOfIteratorHelper(parameterValue.value),
              _step11;
            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var v = _step11.value;
                parameters.push(this.createParameter(v));
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
          } else {
            parameters.push(this.createParameter(parameterValue.value));
          }
        }
        if (parameterValue.type === "raw") {
          if (parameterValue.getSql) {
            return parameterValue.getSql(aliasPath);
          } else {
            return {
              operator: "equal",
              parameters: [aliasPath, parameterValue.value]
            };
          }
        } else if (parameterValue.type === "not") {
          if (parameterValue.child) {
            return {
              operator: parameterValue.type,
              condition: this.getWherePredicateCondition(aliasPath, parameterValue.child)
            };
          } else {
            return {
              operator: "notEqual",
              parameters: [aliasPath].concat(parameters)
            };
          }
        } else if (parameterValue.type === "and") {
          var values = parameterValue.value;
          return {
            operator: parameterValue.type,
            parameters: values.map(function (operator) {
              return _this10.createWhereConditionExpression(_this10.getWherePredicateCondition(aliasPath, operator));
            })
          };
        } else {
          return {
            operator: parameterValue.type,
            parameters: [aliasPath].concat(parameters)
          };
        }
        // } else if (parameterValue === null) {
        //     return {
        //         operator: "isNull",
        //         parameters: [
        //             aliasPath,
        //         ]
        //     };
      } else {
        return {
          operator: "equal",
          parameters: [aliasPath, this.createParameter(parameterValue)]
        };
      }
    }
  }, {
    key: "getWhereCondition",
    value: function getWhereCondition(where) {
      if (typeof where === "string") {
        return where;
      }
      if (InstanceChecker.isBrackets(where)) {
        var whereQueryBuilder = this.createQueryBuilder();
        whereQueryBuilder.parentQueryBuilder = this;
        whereQueryBuilder.expressionMap.mainAlias = this.expressionMap.mainAlias;
        whereQueryBuilder.expressionMap.aliasNamePrefixingEnabled = this.expressionMap.aliasNamePrefixingEnabled;
        whereQueryBuilder.expressionMap.parameters = this.expressionMap.parameters;
        whereQueryBuilder.expressionMap.nativeParameters = this.expressionMap.nativeParameters;
        whereQueryBuilder.expressionMap.wheres = [];
        where.whereFactory(whereQueryBuilder);
        return {
          operator: InstanceChecker.isNotBrackets(where) ? "not" : "brackets",
          condition: whereQueryBuilder.expressionMap.wheres
        };
      }
      if (typeof where === "function") {
        return where(this);
      }
      var wheres = Array.isArray(where) ? where : [where];
      var clauses = [];
      var _iterator12 = _createForOfIteratorHelper(wheres),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _where = _step12.value;
          var conditions = [];
          // Filter the conditions and set up the parameter values
          var _iterator13 = _createForOfIteratorHelper(this.getPredicates(_where)),
            _step13;
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _step13$value = _slicedToArray(_step13.value, 2),
                aliasPath = _step13$value[0],
                parameterValue = _step13$value[1];
              conditions.push({
                type: "and",
                condition: this.getWherePredicateCondition(aliasPath, parameterValue)
              });
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
          clauses.push({
            type: "or",
            condition: conditions
          });
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      if (clauses.length === 1) {
        return clauses[0].condition;
      }
      return clauses;
    }
    /**
     * Creates a query builder used to execute sql queries inside this query builder.
     */
  }, {
    key: "obtainQueryRunner",
    value: function obtainQueryRunner() {
      return this.queryRunner || this.connection.createQueryRunner();
    }
  }, {
    key: "hasCommonTableExpressions",
    value: function hasCommonTableExpressions() {
      return this.expressionMap.commonTableExpressions.length > 0;
    }
  }]);
  return QueryBuilder;
}();